import { ActionTypes } from '../actions/types'
import { getType } from 'typesafe-actions'
import { setDocUploadStartTime } from '../actions/documents'

export interface DocumentState {
  readonly uploadStartTime?: number
}

const initialState: DocumentState = {
  uploadStartTime: undefined,
}

export const documents = (state = initialState, action: ActionTypes) => {
  switch (action.type) {
    case getType(setDocUploadStartTime):
      return {
        ...state,
        uploadStartTime: Date.now(),
      }
    default:
      return state
  }
}

export default documents
